module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "dto text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "dto__header"
  }, [_c('h2', [_vm._v("Håndter versioner af opgaveoversigter")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dto__filters"
  }, [_c('div', {
    staticClass: "dto__filters__row"
  }, [_c('div', {
    staticClass: "dto__filters__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skoleår")]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dto__filters__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Titler")]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Titler",
      "tags": _vm.titleOptions,
      "selectedTags": _vm.selectedTitles
    },
    on: {
      "select": _vm.toggleTitle,
      "clear": _vm.clearTitles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dto__filters__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Personer")]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Personer",
      "tags": _vm.personOptions,
      "selectedTags": _vm.selectedPersons
    },
    on: {
      "select": _vm.togglePerson,
      "clear": _vm.clearPersons
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dto__filters__field"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Grupper")]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "tags": _vm.tags,
      "selectedTags": _vm.selectedGroups
    },
    on: {
      "select": _vm.toggleGroup,
      "clear": _vm.clearGroups
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dto__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "dto__loading"
  }, [_c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  })], 1) : [(_vm.rows.length < 1) ? _c('p', {
    staticClass: "dto__empty text-explainer"
  }, [_vm._v("\n          Der er ingen gemte versioner for dette skoleår.\n        ")]) : (_vm.filteredRows.length < 1) ? _c('p', {
    staticClass: "dto__empty text-explainer"
  }, [_vm._v("\n          Ingen versioner matcher de valgte filtre.\n        ")]) : _c('table', {
    staticClass: "dto__table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "dto__table__check"
  }, [_c('div', {
    staticClass: "do-checkbox",
    class: {
      'do-checkbox--selected': _vm.isAllFilteredSelected
    },
    on: {
      "click": _vm.toggleSelectAll
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "dto__table__sortable",
    on: {
      "click": function($event) {
        return _vm.setSort('name')
      }
    }
  }, [_vm._v("\n                Navn "), (_vm.sortKey === 'name') ? _c('span', {
    staticClass: "icon-menu-open dto__table__sort-icon",
    class: {
      'dto__table__sort-icon--desc': _vm.sortDir === 'desc'
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "dto__table__sortable",
    on: {
      "click": function($event) {
        return _vm.setSort('title')
      }
    }
  }, [_vm._v("\n                Titel "), (_vm.sortKey === 'title') ? _c('span', {
    staticClass: "icon-menu-open dto__table__sort-icon",
    class: {
      'dto__table__sort-icon--desc': _vm.sortDir === 'desc'
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "dto__table__sortable",
    on: {
      "click": function($event) {
        return _vm.setSort('createdAt')
      }
    }
  }, [_vm._v("\n                Gemt "), (_vm.sortKey === 'createdAt') ? _c('span', {
    staticClass: "icon-menu-open dto__table__sort-icon",
    class: {
      'dto__table__sort-icon--desc': _vm.sortDir === 'desc'
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "dto__table__actions"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedRows), function(row) {
    return _c('tr', {
      key: row.id,
      staticClass: "dto__table__row",
      class: {
        'dto__table__row--selected': _vm.isSelected(row.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggleRow(row.id)
        }
      }
    }, [_c('td', {
      staticClass: "dto__table__check"
    }, [_c('div', {
      staticClass: "do-checkbox",
      class: {
        'do-checkbox--selected': _vm.isSelected(row.id)
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.createdAtFormatted))]), _vm._v(" "), _c('td', {
      staticClass: "dto__table__actions"
    }, [_c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--warning bttn-danger",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.askDeleteRow(row)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                ")]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openRow(row)
        }
      }
    }, [_vm._v("Åbn")]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.printRow(row)
        }
      }
    }, [_vm._v("Print")])])])
  }), 0)])]], 2), _vm._v(" "), _c('div', {
    staticClass: "dto__footer"
  }, [_c('span', {
    staticClass: "dto__footer__count"
  }, [_vm._v(_vm._s(_vm.selectedIds.length) + " valgt")]), _vm._v(" "), _c('div', {
    staticClass: "dto__footer__buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.selectedIds.length < 1,
      'do-bttn--submit--loading': _vm.isLoadingPrint
    },
    on: {
      "click": _vm.startPrint
    }
  }, [_vm._v("\n          Print " + _vm._s(_vm.selectedIds.length) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--warning bttn-danger",
    class: {
      'bttn-primary--disabled': _vm.selectedIds.length < 1
    },
    on: {
      "click": _vm.askDelete
    }
  }, [_vm._v("\n          Slet valgte\n        ")])])])])]), _vm._v(" "), (_vm.isPrinting) ? _c('div', {
    staticClass: "dto-print-source",
    attrs: {
      "id": "printSelectedTaskOverviews",
      "aria-hidden": "true"
    }
  }, _vm._l((_vm.rowsToPrint), function(row) {
    return _c('TaskOverviewUser', {
      key: row.id,
      attrs: {
        "user": _vm.userForRow(row),
        "version": row.version,
        "isHideTaskHoursUnderThreshold": true
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.isDeleteWarningActive) ? _c('DModal', {
    attrs: {
      "appendToBody": true,
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-warning text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "?")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Slet " + _vm._s(_vm.pendingDeleteIds.length) + " version(er)?")]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.delete_warning_message')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isDeleteWarningActive = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--warning bttn-danger",
    class: [{
      'bttn--loading': _vm.isDeleting
    }],
    on: {
      "click": _vm.deleteConfirmed
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.delete')) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.activeVersion) ? _c('DModal', {
    attrs: {
      "appendToBody": true,
      "isBgOverlay": true,
      "showClose": false
    },
    on: {
      "close": function($event) {
        _vm.activeVersion = null
      }
    }
  }, [_c('div', {
    staticClass: "dto-view text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "dto-view__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.activeUser ? _vm.activeUser.name : ''))]), _vm._v(" "), _c('div', {
    staticClass: "dto-view__header__right"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--warning bttn-danger do-bttn--small",
    on: {
      "click": _vm.askDeleteActive
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        _vm.activeVersion = null
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dto-view__body"
  }, [(_vm.activeUser) ? _c('TaskOverviewUser', {
    attrs: {
      "user": _vm.activeUser,
      "version": _vm.activeVersion
    }
  }) : _vm._e()], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a83f7420!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverview/DeleteTaskOverviews.vue
// module id = 2082
// module chunks = 1